/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
import Backbone from 'backbone';

import lazyLoadView from '@/util/lazyLoadView';
import showModal from '@/util/showModal';

import GetAllAssetProblemStatuses from '../../services/GetAllAssetProblemStatuses';
import SearchAssetProblems from '../../services/SearchAssetProblems';
import SaveAssetProblem from '../../services/SaveAssetProblem';
import loadSearchFields from '../../../login/loaders/SearchFieldsViewLoader';
import LoggedProblemsGridView from '../LoggedProblemsGridView/LogAProblemGridView';
import LogAProblemModalView from '../LogAProblemModalView/LogAProblemModalView';

import tmplLogAProblemView from './LogAProblemView.hbs';

const LogAProblemView = View.extend({
  template: tmplLogAProblemView,

  ui: {
    searchFieldsView: '.search-fields-view',
    btnLogProblem: '.btn-log-problem',
    loggedProblemsGridView: '.logged-problems-grid-view'
  },

  regions: {
    searchFieldsView: '@ui.searchFieldsView',
    loggedProblemsGridView: '@ui.loggedProblemsGridView'
  },

  events: {
    'click @ui.btnLogProblem': 'onClickOpenLogAProblemModal'
  },

  childViewEvents: {
    'search:response': 'onSearchResponse',
    'status:updated' : 'updateStatus'
  },

  onRender() {
    const searchFields = [
        {
          id: 'contract-number',
          name: 'contractNumber',
          class: 'InputSearchField',
          placeholder: 'Contract Number'
        },
        {
          id: 'serial-number',
          name: 'serialNumber',
          class: 'InputSearchField',
          placeholder: 'Serial Number'
        },
        {
          id: 'created-on-start',
          name: 'createdOnStart',
          class: 'DateSearchField',
          placeholder: 'Created On Start'
        },
        {
          id: 'created-on-end',
          name: 'createdOnEnd',
          class: 'DateSearchField',
          placeholder: 'Created On End'
        },
        {
          id: 'status-id',
          name: 'statusId',
          class: 'SelectSearchField',
          placeholder: 'Status',
          lookupService: GetAllAssetProblemStatuses,
          lookupMapping: (status) => {
              const { problemStatus, id } = status;
              return { optionText: problemStatus, id };
          }
        },
    ]

    this.showChildView(
        'searchFieldsView',
        lazyLoadView(() => loadSearchFields(searchFields, SearchAssetProblems))
    );

    this.loggedProblemsGridView = new LoggedProblemsGridView({
        pageSize: 10,
        model: new Backbone.Model({})
      });
      this.showChildView('loggedProblemsGridView', this.loggedProblemsGridView);
  },

  onSearchResponse(response) {
    this.$('.result-count').empty().append(`<span><b>Total Result Count: ${response.totalCount}</b></span>`);
    this.loggedProblemsGridView.collection.fullCollection.reset(response.assetProblems);
  },

  async onClickOpenLogAProblemModal(e) {
    e?.preventDefault()

    await showModal({
      title: 'Log a Problem',
      view: new LogAProblemModalView({}),
      dialogClasses: 'modal-lg'
    }).then((modalData) => {
      SaveAssetProblem(modalData);
    });
  },

  async updateStatus() {
    this.loggedProblemsGridView.collection.fullCollection.reset(this.loggedProblemsGridView.collection.fullCollection.models)
  }
});

export default LogAProblemView;
